import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import logoImage from '../../assets/images/TELUS-logo-white.gif';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Footer = ({ disclaimer = true, showFooter = true }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    FOOTER: { DISCLAIMER_MESSAGE, COPYRIGHT_MESSAGE }
  } = localizedStrings;

  const copyrightYear = new Date().getFullYear();

  return (
    <>
      {disclaimer && (
        <div id="disclaimer" align="center">
          {DISCLAIMER_MESSAGE}
        </div>
      )}

      {showFooter && (
        <div id="footer" align="center">
          <img src={logoImage} title="TELUS" alt="Telus logo" />
          <Typography block>
            &copy; {copyrightYear} {COPYRIGHT_MESSAGE}
          </Typography>
        </div>
      )}
    </>
  );
};

Footer.propTypes = {
  disclaimer: PropTypes.bool,
  showFooter: PropTypes.bool
};

export default Footer;
